import { render, staticRenderFns } from "./AssignedRules.vue?vue&type=template&id=a9102fda"
import script from "./AssignedRules.vue?vue&type=script&lang=js"
export * from "./AssignedRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports